"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _turingFooter = _interopRequireDefault(require("../uiux/turing-footer/turing-footer"));
var _turingHeader = _interopRequireDefault(require("../uiux/turing-header/turing-header.js"));
var _scrollbarsVertical = _interopRequireDefault(require("../uiux/scrollbars/scrollbars-vertical.js"));
var _ScrollableContainer = _interopRequireDefault(require("./scrollbars/ScrollableContainer.js"));
var _antd = require("antd");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
//import './Content.css';
// Turing components
var AntHeader = _antd.Layout.Header,
  Content = _antd.Layout.Content,
  AntFooter = _antd.Layout.Footer;
function LayoutPage(props) {
  console.log('LayoutPage props', props);
  return /*#__PURE__*/_react["default"].createElement(_ScrollableContainer["default"], {
    vertical: true,
    backgroundColor: "#fcfcfc",
    containerClassName: "appContentContainer",
    scrollableClassName: "contentItems"
  }, /*#__PURE__*/_react["default"].createElement(AntHeader, null, /*#__PURE__*/_react["default"].createElement(_turingHeader["default"], {
    menuItems: props.menuItems,
    featuredFunctions: props.featuredFunctions,
    contextPanel: props.contextPanel
  })), /*#__PURE__*/_react["default"].createElement(Content, null, props.content), /*#__PURE__*/_react["default"].createElement(AntFooter, null, /*#__PURE__*/_react["default"].createElement(_turingFooter["default"], {
    backgroundColor: "#f0f0f0"
  })));
}
var _default = exports["default"] = LayoutPage;